import DataTable from 'datatables.net-bs5';
window.DataTable = DataTable;
import 'datatables.net-responsive-dt';
import 'datatables.net-responsive-bs5';

import 'datatables.net-buttons-bs5';
import 'datatables.net-buttons/js/buttons.colVis.mjs';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';

import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-dt/css/responsive.dataTables.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';